import { normalizeLocale } from 'src/i18n/config'

const DEFAULT_LINK_LOCALES = ['pl', 'en']

const hasTitle = (translation) => Boolean(translation?.title?.trim())

// Tłumaczenie aktualności na liście: w języku strony, a gdy w nim nie ma tytułu — pierwsze tłumaczenie z tytułem.
// `contentLocale` to język zwróconej treści; adres detalu budujemy w nim, bo slug jest osobny dla każdego języka.
export const getNewsTranslation = (news, locale) => {
  const translations = news?.translations || {}
  const own = translations[locale] || translations[normalizeLocale(locale)] || null

  if (hasTitle(own)) {
    return { translation: own, contentLocale: locale }
  }

  const fallback = Object.entries(translations).find(([, translation]) => hasTitle(translation))

  return fallback
    ? { translation: fallback[1], contentLocale: fallback[0] }
    : { translation: own || {}, contentLocale: locale }
}

const isLinkableLocale = (contentLocale, locale, linkLocales) =>
  normalizeLocale(contentLocale) === normalizeLocale(locale) ||
  (linkLocales?.length ? linkLocales : DEFAULT_LINK_LOCALES)
    .map(normalizeLocale)
    .includes(normalizeLocale(contentLocale))

// Język adresu detalu: język treści, jeśli strona go ma (na domenie czasopisma języki jego strony, w portalu
// i na stronie wydawcy polski i angielski). Inaczej, gdy detal szuka sluga we wszystkich językach
// (`anySlugLocale`, domena czasopisma), język strony; w pozostałych przypadkach `null` — bez linku.
export const getNewsLinkLocale = (contentLocale, locale, { linkLocales = null, anySlugLocale = false } = {}) =>
  isLinkableLocale(contentLocale, locale, linkLocales) ? contentLocale : anySlugLocale ? locale : null

// Aktualność do pokazania w języku strony, gdy treść ma tylko w innym: tłumaczenia języka treści (jej, bloków
// i ich elementów) podstawione pod język strony, więc nagłówek i bloki czytają je jak zwykle.
export const withNewsContentLocale = (news, locale) => {
  const { contentLocale } = getNewsTranslation(news, locale)

  if (!news || contentLocale === locale) {
    return news
  }

  const substitute = (value) => {
    if (Array.isArray(value)) {
      return value.map(substitute)
    }

    if (!value || typeof value !== 'object') {
      return value
    }

    const copy = Object.fromEntries(Object.entries(value).map(([key, item]) => [key, substitute(item)]))
    const translations = copy.translations

    if (
      translations &&
      typeof translations === 'object' &&
      !Array.isArray(translations) &&
      translations[contentLocale]
    ) {
      copy.translations = { ...translations, [locale]: translations[contentLocale] }
    }

    return copy
  }

  return substitute(news)
}
